import { userInfoFrag } from '../../../../utils/type/user.common-type';
import { workOfferInfoFrag } from '../../../../utils/type/work.common-types';

export const getWorkFrag = `
    id
    serviceId
    folderId
    person {
        id
    }
    dateFrom
    tags
    users {
        ${userInfoFrag}
    }
    ${workOfferInfoFrag}
    workData {
        ... on WorkDataContinuousRecordObject {
            data
            form
            presence
        }
    }
`;
